import { render, staticRenderFns } from "./WholesaleProductItemDetail.vue?vue&type=template&id=f908b02e&scoped=true&"
import script from "./WholesaleProductItemDetail.vue?vue&type=script&lang=js&"
export * from "./WholesaleProductItemDetail.vue?vue&type=script&lang=js&"
import style0 from "./WholesaleProductItemDetail.vue?vue&type=style&index=0&id=f908b02e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f908b02e",
  null
  
)

export default component.exports